import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

export const Wrapper = styled(Row)`
    border-bottom: ${globalThis.config.border.small};
    margin: 0;
    background-color: ${globalThis.config.colors.white};
    z-index: 100;
    padding-top: 0px;
    position: fixed;
    width: 100%;
`;

export const IndentColumn = styled(Col)`
    flex: 0 0 4%;
`;

export const Column = styled(Col)`
    padding: 0;
    border-right: ${globalThis.config.border.small};
    text-align: left;
    display: flex;
    align-items: center;

    &:last-child {
        border-right: none;
    }
`;

export const ItemColum = styled(Col)`
    padding: 1em 0;
    border-right: ${globalThis.config.border.small};
    display: grid;
    justify-content: center;
    align-content: center;

    &:last-child {
        border-right: none;
    }
`;

export const ItemColumLabel = styled.div`
    font-size: 0.6rem;
`;
